import $http from "../../../axios";
import {MessageBox, Notification} from 'element-ui';

// Agregar items al carrito
export async function addCartItems({commit, state, dispatch, rootState}, products) {
    commit('setLockAdd', true);
    commit('setLockPromotions', true);
    commit('catalog/setAddingProduct', products, {root: true});
    
    let two_days_ago = new Date();
    two_days_ago.setDate(two_days_ago.getDate() - 2);
    if (rootState.catalog.date_of_fetch && rootState.catalog.date_of_fetch <= two_days_ago) {
        Notification.error({
            title: "¡Error!",
            message: 'Se recomienda listar el catalogo de nuevo',
            type: "error",
            duration: 5000,
            customClass: "notification-box"
        });
        commit('setLockAdd', false);
        commit('setLockPromotions', false);
        commit('catalog/quitAddingProduct', [], {root: true});  
        return;
    }

    products.model_id = state.selected_model.id;
    products.warehouse_id = rootState.login.user_b2b.id;
    products.branchoffice_id = rootState.login.user_b2b.branchoffice_id;
    products.return_document = 0;

    await $http.post('/api/items-carrito', products).then(async () => {
        await dispatch('fetchCart', {
            contact_id: rootState.login.user_b2b.contact_id,
            branchoffice_id: rootState.login.user_b2b.id,
            user_id: rootState.login.user_logued.id
        });
    }).catch(error => {
        if (error.response && error.response.data && error.response.data.message){
            Notification.error({
                title: "¡Error!",
                message: error.response.data.message,
                type: "error",
                duration: 5000,
                customClass: "notification-box"
            });
        }
    });

    commit('setLockAdd', false);
    commit('setLockPromotions', false);
    commit('catalog/quitAddingProduct', [], {root: true});
}

// Eliminar items del carrito
export async function removeCartItems({ commit, dispatch, rootState }, item) {
    await $http.delete(`/api/items-carrito/${item.id}`).then(async response => {
        await commit("deleteItemCart", item);
        await dispatch("fetchCart", {
            contact_id: rootState.login.user_b2b.contact_id,
            branchoffice_id: rootState.login.user_b2b.id,
            user_id: rootState.login.user_logued.id
        });
    });
}

// Crear nuevo carrito
export async function newCart({ commit, state, rootState }, cart) {
    cart.branchoffice_id = rootState.login.user_b2b.branchoffice_id
    await $http
        .post("/api/carrito", cart)
        .then(response => {
            commit("setCart", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "¡Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
}

// Obtener los datos del carrito
export async function fetchCart({ commit, state }, parameters) {
    await $http
        .get(
            `/api/carrito/${parameters.contact_id}/${parameters.branchoffice_id}/${parameters.user_id}`
        )
        .then(async response => {
            await commit("setCart", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "¡Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
}

/* Agregar items relacionados al carrito */
export async function addToCartFinalize(
    { rootState, dispatch },
    { id, cant, price, line_id, subline_id, brand_id, percentage_iva_sale }
) {
    let product = {
        document_id: rootState.cart.cart.id,
        product_id: id,
        seller: rootState.login.user_b2b.seller_id,
        line_id: line_id,
        subline_id: subline_id,
        brand_id: brand_id,
        applies_inventory: true,
        quantity: cant,
        unit_value_before_taxes: price.price,
        iva_percentage: percentage_iva_sale,
        discount_value: Math.round((price.price * price.percentage) / 100)
    };

    await dispatch("addCartItems", product);
}

/* Agregar información del carrito */
export async function addInformation({ commit, state }, information) {
    await $http
        .post("/api/informacion-carrito", information)
        .then(response => {
            commit("setInformation", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "¡Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
}

/* Finalizar proceso de pedido */
export async function finalizeOrderAction({dispatch, rootState, commit, state}, cart) {
    // Validamos el monto mini por pedido
    let minimum_order_amount = rootState.login.user_b2b.branchoffice.minimum_order_amount;

    if (minimum_order_amount) {
        if (cart.total_value < minimum_order_amount) {
            commit('cartError', 'El valor total del pedido es inferior al monto mínimo.');

            return;
        }
    }

    let data = {
        id: cart.id,
        observation: cart.observation,
        affects_prefix_document: cart.affects_prefix_document,
        affects_number_document: cart.affects_number_document,
        model_code: '010'
    };

    let vouchertype_id = await dispatch('getVouchertype', {
        code: '001',
        branchoffice: rootState.login.user_b2b.branchoffice_id
    });

    await $http
        .post(`/api/finalizar-pedido`, data)
        .then(async response => {
            // Preparar datos obligatorios del carrito
            let cart = {
                warehouse_id: rootState.login.user_b2b.id,
                vouchertype_id: vouchertype_id,
                prefix: 'Pd',
                contact_id: rootState.login.user_b2b.contact_id,
                inventory_operation: 'pedido',
                in_progress: true,
                pay_condition: rootState.login.user_b2b.pay_condition,
                send_point: rootState.login.user_b2b.send_point,
                seller_id: rootState.login.user_b2b.seller_id,
                user_id: rootState.login.user_logued.id,
                documents_information: {
                    price_list: rootState.login.user_b2b.price_list_id
                }
            };
            // Crear carrito
            await dispatch('newCart', cart);
            //console.log(response.data);
            commit('setLastCart', response.data);
            commit('cartError', '');
        })
        .catch(error => {
            let data = error.response.data
            Notification.error({
                title: 'Error!',
                message: 'Error al finalizar el pedido',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
            if (data.dps_new_price) {
                console.log(2);

                commit(
                    'cartError',
                    `Estimado Cliente. <br> ${data.message}.`
                );
                commit('serDpNewPrice', data.dps_new_price);
            } else if ( data.type == 'minimalprice') {
                commit(
                    'cartError',
                    `Estimado Cliente. <br> ${data.message}.`
                );
                commit('serDpNewPrice', data.dps_new_price);
            }else{
                console.log(1);
                commit(
                    'cartError',
                    'Estimado Cliente. <br> Estamos presentando algunos problemas de comunicación, por favor intentelo nuevamente.'
                );
            }
        });
}

/**
 * Finalizar cotización
 */
export async function finalizeQuotation({dispatch, rootState, commit, state}, cart) {
    // Validamos el monto mínimo de la cotización
    let minimum_order_amount = rootState.login.user_b2b.branchoffice.minimum_order_amount;

    if (minimum_order_amount) {
        if (cart.total_value < minimum_order_amount) {
            commit('cartError', 'El valor total de la cotización es inferior al monto mínimo.');

            return;
        }
    }

    let data = {
        id: cart.id,
        observation: cart.observation,
        affects_prefix_document: cart.affects_prefix_document,
        affects_number_document: cart.affects_number_document,
        model_code: '005'
    };

    let voucher_type_id = await dispatch('getVouchertype', {
        code: '001',
        branchoffice: rootState.login.user_b2b.branchoffice_id
    });

    await $http
        .post(`/api/finalizar-pedido`, data)
        .then(async response => {

            // Preparar datos obligatorios del carrito
            let cart = {
                warehouse_id: rootState.login.user_b2b.id,
                vouchertype_id: voucher_type_id,
                prefix: 'Pd',
                contact_id: rootState.login.user_b2b.contact_id,
                inventory_operation: 'pedido',
                in_progress: true,
                pay_condition: rootState.login.user_b2b.pay_condition,
                send_point: rootState.login.user_b2b.send_point,
                seller_id: rootState.login.user_b2b.seller_id,
                user_id: rootState.login.user_logued.id,
                documents_information: {
                    price_list: rootState.login.user_b2b.price_list_id
                }
            };

            // Crear cotización
            await dispatch('newCart', cart);
            commit('setLastCart', response.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: 'Error al finalizar el pedido',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });

            commit(
                'cartError',
                'Estimado Cliente. <br> Estamos presentando algunos problemas de comunicación, por favor inténtelo nuevamente.'
            );
        });
}

export async function getVouchertype({commit, state},voucherType){
    var params = {
        code_voucher_type:voucherType.code,
        branchoffice: voucherType.branchoffice
    }
    var voucherType_id
    await $http
        .get(`/api/tipo-comprobante`, {params})
        .then(response => {
            if (response.data) {
                voucherType_id = response.data.id
            }
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
    return voucherType_id
}

export async function getModelBycode({commit, state},code){
    await $http
        .get(`/api/modelo-por-codigo/${code}`)
        .then(response => {
            if (response.data.data) {
                commit("setSelectedModel", response.data.data);
            }
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
}


export async function getPdf({ commit, state }, id) {
    await $http
        .get(`/api/imprimir-pedido/${id}`)
        .then(response => {
            commit("setPdf", response.data.data.pdf);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
}

export async function getCustomerCategoty({ commit, state }, contact_customer_id) {
    let contactCustomer = null
    await $http
        .get(`/api/categoria-cliente-prospecto/${contact_customer_id}`)
        .then(response => {
            contactCustomer = response.data.data
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
    return contactCustomer
}
export async function downloadDocument({ state }) {
    let name = state.pdf.split("/").pop();
    // let extension = name.split('.').pop()
    await $http({
        url: state.pdf,
        method: "GET",
        responseType: "blob" // important
    })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 3000,
                customClass: "notification-box"
            });
        });
}

/* Agregar items al carrito */
export async function addToCart({ rootState, dispatch, state }, product) {

    let user = JSON.parse(localStorage.getItem('user'));
    let user_b2b = JSON.parse(localStorage.getItem('user_b2b'));

    let discount_value = 0;

    if (!product.combo && user.subscribers[0] && user.subscribers[0].identification !== '900338016' && user_b2b.discount_percentage != null && product.price.price){
        discount_value = (product.price.price * parseFloat(user_b2b.discount_percentage)) / 100 * product.quantity;
    }

    let addProduct = {
        vr_unit_portal: product.price.price,
        product_id: product.product_id ? product.product_id : product.id,
        seller_id: rootState.login.user_b2b.seller_id,
        contact_id: rootState.login.user_b2b.contact.id,
        quantity: product.quantity,
        original_quantity: product.quantity,
        model_id: state.selected_model.id,
        promotion_id: product.promotion_id,
        is_benefit: product.is_benefit ? product.is_benefit : false,
        discount_value: discount_value,
        document_product_id: product.document_product_id,
        unit_value_before_taxes: product.price
            ? product.price.price
            : undefined
    };

    let vouchertype_id = await dispatch("getVouchertype", {code:'001', branchoffice: rootState.login.user_b2b.branchoffice_id});

    // Validar si el carrito existe
    if (!state.cart.id) {
        // Preparar datos obligatorios del carrito
        let cart = {
            warehouse_id: rootState.login.user_b2b.id,
            vouchertype_id: vouchertype_id,
            prefix: "Pd",
            contact_id: rootState.login.user_b2b.contact_id,
            inventory_operation: "pedido",
            in_progress: true,
            model_id: state.selected_model.id,
            pay_condition: rootState.login.user_b2b.pay_condition,
            send_point: rootState.login.user_b2b.send_point,
            seller_id: rootState.login.user_b2b.seller_id,
            user_id: rootState.login.user_logued.id,
            documents_information: {
                price_list: rootState.login.user_b2b.price_list_id
            }
        };

      // Crear carrito
      await dispatch("newCart", cart);
    }

    // Asignar el id del carrito
    addProduct.document_id = rootState.cart.cart.id;
    // Agregar producto al carrito
    if (addProduct.quantity > 0) {
      await dispatch("addCartItems", addProduct);
    }
  }

export async function checkCart({ rootState, dispatch, state }) {
    // Validar si el carrito existe
    let vouchertype_id = await dispatch("getVouchertype", {code:'001', branchoffice: rootState.login.user_b2b.branchoffice_id});

    if (!state.cart.id) {
        // Preparar datos obligatorios del carrito
        let cart = {
            warehouse_id: rootState.login.user_b2b.id,
            vouchertype_id: vouchertype_id,
            prefix: "Pd",
            contact_id: rootState.login.user_b2b.contact_id,
            inventory_operation: "pedido",
            in_progress: true,
            pay_condition: rootState.login.user_b2b.pay_condition,
            send_point: rootState.login.user_b2b.send_point,
            seller_id: rootState.login.user_b2b.seller_id,
            user_id: rootState.login.user_logued.id,
            documents_information: {
                price_list: rootState.login.user_b2b.price_list_id
            }
        };

        // Crear carrito
        await dispatch("newCart", cart);
    }
}

/* Agregar productos de promoción al carrito */
//Obsoleto
export async function addPromotionToCart(
    { state, rootState, dispatch },
    product
) {
    let productAdd = {
        product_id: product.id,
        promotion_id: product.promotion,
        seller: rootState.login.user_b2b.seller_id,
        applies_inventory: false,
        quantity: product.quantity,
        unit_value_before_taxes: product.price.price,
        discount_value: Math.round((product.price.price * product.discount) / 100),
        original_quantity: product.quantity,
        line_id: product.line_id,
        brand_id: product.brand_id,
        subbrand_id: product.subbrand_id,
        subline_id: product.subline_id,
        category_id: product.category_id
    };
    let vouchertype_id = await dispatch("getVouchertype", {code:'001', branchoffice: rootState.login.user_b2b.branchoffice_id});

    // Validar si el carrito existe
    if (rootState.cart.cart.id == null || rootState.cart.cart.id == "") {
        // Preparar datos obligatorios del carrito
        let cart = {
            warehouse_id: rootState.login.user_b2b.id,
            vouchertype_id: vouchertype_id,
            prefix: "Pd",
            contact_id: rootState.login.user_b2b.contact_id,
            inventory_operation: "pedido",
            in_progress: true,
            pay_condition: rootState.login.user_b2b.pay_condition,
            send_point: rootState.login.user_b2b.send_point,
            seller_id: rootState.login.user_b2b.seller_id,
            user_id: rootState.login.user_logued.id,
            documents_information: {
                price_list: rootState.login.user_b2b.price_list_id
            }
        };

        // Crear carrito
        await dispatch("newCart", cart);

        // Obtener el id del carrito recién creado
        productAdd.document_id = rootState.cart.cart.id;

        // Agregar producto al carrito
        await dispatch("addCartItems", productAdd);
    } else {
        // Asignar el id del carrito
        productAdd.document_id = rootState.cart.cart.id;

        // Agregar producto al carrito
        await dispatch("addCartItems", productAdd);
    }
}

/** Aplicar descuento a la promoción cuando se cumple */
export async function applyBenefit(
    { state, commit, dispatch, rootState },
    promotion
) {
    // Agregar el beneficio al carrito o actualizar las unidades del beneficio
    if (promotion.comply && promotion.specific_product != null) {
        let product = {
            id: promotion.specific_product.id,
            quantity: promotion.specific_product.quantity,
            promotion_id: promotion.id,
            is_benefit: true
        };
        await dispatch("addToCart", product);
    }
}

/**
 * Obtiene el modelo de acuerdo al id del mismo
 * @param commit
 * @param state
 * @param requestParameters
 * @returns {Promise<void>}
 */
export async function fetchModel({ commit, state }, model_id) {
    await $http
        .get("/api/modelos/" + model_id)
        .then(response => {
            commit("setSelectedModel", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "¡Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/b2b/modules/cart/actions.js